var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('h2',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }